import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import router from "@/router";
  import store from "@/store";
  import { useToast } from "vue-toastification";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SelectOptionToGenerateContractModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    eoiId: {
      type: Object,
      required: true,
    },
    isDocusignEnabled: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close", "generateContract"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const toast = useToast();

  const props = __props;

  const close = () => {
    emits("close");
  };

  const generate = () => {
    emits("generateContract");
  };

const __returned__ = { emits, toast, props, close, generate, ref, Modal, get router() { return router }, get store() { return store }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})